import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'
import AppShell from '@/components/AppShell'
import AdminShell from '@/components/AdminShell'
import AtendimentoLayout from '@/components/AtendimentoLayout'
import { useAuth } from '@/contexts/AuthContext'

import HomePage from '@/pages/HomePage'
import LoginPage from '@/pages/LoginPage'
import OnboardingPage from '@/pages/OnboardingPage'
import AgendaPage from '@/pages/AgendaPage'
import AgendaNovaPage from '@/pages/AgendaNovaPage'
import AtendimentoPage from '@/pages/atendimento/AtendimentoPage'
import AtendimentoConversaPage from '@/pages/atendimento/AtendimentoConversaPage'
import AtendimentoChatbotPage from '@/pages/atendimento/AtendimentoChatbotPage'
import AtendimentoAgendaIaPage from '@/pages/atendimento/AtendimentoAgendaIaPage'
import PacientesPage from '@/pages/PacientesPage'
import PacientesNovoPage from '@/pages/PacientesNovoPage'
import PacientesDetalhePage from '@/pages/PacientesDetalhePage'
import PendenciasPage from '@/pages/PendenciasPage'
import PendenciasNovaPage from '@/pages/PendenciasNovaPage'
import MensagensPage from '@/pages/MensagensPage'
import MensagensThreadPage from '@/pages/MensagensThreadPage'
import NotificacoesPage from '@/pages/NotificacoesPage'
import ProtocolosPage from '@/pages/ProtocolosPage'
import TermosPage from '@/pages/TermosPage'
import ClinicasPage from '@/pages/ClinicasPage'
import EquipePage from '@/pages/EquipePage'
import ConfiguracoesPage from '@/pages/ConfiguracoesPage'
import ConfiguracoesWhatsAppPage from '@/pages/ConfiguracoesWhatsAppPage'
import MaisPage from '@/pages/MaisPage'
import ConvitePage from '@/pages/ConvitePage'
import PacientePublicoPage from '@/pages/PacientePublicoPage'
import AdminHomePage from '@/pages/admin/AdminHomePage'
import AdminMedicosPage from '@/pages/admin/AdminMedicosPage'
import AdminNovoMedicoPage from '@/pages/admin/AdminNovoMedicoPage'
import AdminWorkspacePage from '@/pages/admin/AdminWorkspacePage'

function ProtectedRoute() {
  const { user, loading, allowSelfSignup, isPlatformAdmin, workspaces, adminWorkspaceMode } = useAuth()
  const location = useLocation()

  if (loading) return null
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />

  const needsOnboarding = workspaces.length === 0 && !adminWorkspaceMode && !isPlatformAdmin
  if (needsOnboarding && allowSelfSignup) {
    return <Navigate to="/onboarding" replace />
  }
  if (needsOnboarding && !allowSelfSignup && !isPlatformAdmin) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}

function AdminRoute() {
  const { user, loading, isPlatformAdmin } = useAuth()
  const location = useLocation()

  if (loading) return null
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  if (!isPlatformAdmin) return <Navigate to="/" replace />

  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  )
}

function PublicOnlyRoute() {
  const { user, loading } = useAuth()
  if (loading) return null
  if (user) return <Navigate to="/" replace />
  return <Outlet />
}

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/login" element={<PublicOnlyRoute />}>
          <Route index element={<LoginPage />} />
        </Route>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/convite/:token" element={<ConvitePage />} />
        <Route path="/p/:token" element={<PacientePublicoPage />} />

        <Route path="/admin" element={<AdminRoute />}>
          <Route index element={<AdminHomePage />} />
          <Route path="medicos" element={<AdminMedicosPage />} />
          <Route path="medicos/novo" element={<AdminNovoMedicoPage />} />
          <Route path="workspaces/:id" element={<AdminWorkspacePage />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route index element={<HomePage />} />
          <Route path="agenda" element={<AgendaPage />} />
          <Route path="agenda/nova" element={<AgendaNovaPage />} />
          <Route path="atendimento" element={<AtendimentoLayout />}>
            <Route index element={<AtendimentoPage />} />
            <Route path=":id" element={<AtendimentoConversaPage />} />
            <Route path="chatbot" element={<AtendimentoChatbotPage />} />
            <Route path="agenda-ia" element={<AtendimentoAgendaIaPage />} />
          </Route>
          <Route path="pacientes" element={<PacientesPage />} />
          <Route path="pacientes/novo" element={<PacientesNovoPage />} />
          <Route path="pacientes/:id" element={<PacientesDetalhePage />} />
          <Route path="pendencias" element={<PendenciasPage />} />
          <Route path="pendencias/nova" element={<PendenciasNovaPage />} />
          <Route path="mensagens" element={<MensagensPage />} />
          <Route path="mensagens/:id" element={<MensagensThreadPage />} />
          <Route path="notificacoes" element={<NotificacoesPage />} />
          <Route path="protocolos" element={<ProtocolosPage />} />
          <Route path="termos" element={<TermosPage />} />
          <Route path="clinicas" element={<ClinicasPage />} />
          <Route path="equipe" element={<EquipePage />} />
          <Route path="configuracoes" element={<ConfiguracoesPage />} />
          <Route path="configuracoes/whatsapp" element={<ConfiguracoesWhatsAppPage />} />
          <Route path="mais" element={<MaisPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  )
}
